export default __webpack_public_path__ + "static/logo_leaders-906362653c0bc4a2adb965a9c372d408.jpeg";